import React, { Component } from 'react'
import Button from 'components/button/button'

import moment from 'moment'

import {
	deleteItem,
	deleteTodo,
	deleteFile,
	deleteFileVersion,
	deleteOrganisation,
	openModal
} from 'state/actions'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import Icon from 'components/icon/icon'

import { 
	paragraphToLines,
	timeStringFromSession
} from 'utils'

import { 
	getCurrentAccount,
	getCurrentUser
} from 'state/selectors'

import {
	some
} from 'lodash'

class ModalDelete extends Component {
	item = {}
	state = {
		checkOptionStatus: false
	}

	UNSAFE_componentWillUpdate = nextProps => {
		if(this.props.dataType == 'organisation'){
			if(!nextProps.accountData || this.props.accountData.id !== nextProps.accountData.id){
				this.deleteOrganisation()
			}
		}
	}

	deleteOrganisation = _ => {
		this.props.deleteOrganisation(this.item, _ => {
			this.successCallback()

			setTimeout(_ => {
				this.props.openModal('swap', 'organisation', null)
			}, 300)
		})
	}

	doAction() {
		const {
			setLoading,
			dataType,
			deleteTodo,
			deleteFile,
			deleteFileVersion,
			deleteItem,
			allFiles,
			data,
			currentAccount,
			accountData,
			userData,
			allAccounts,
			history
		} = this.props

		setLoading(true)

		switch (dataType) {
			case 'todo':
				deleteTodo(this.item, _ => {
					this.successCallback()
				})
				break
			case 'file':
				deleteFile(this.item, _ => {
					this.successCallback()
				})
				break
			case 'version':
				let tempFile = allFiles[this.item.file_id]

				if (tempFile.versions.length === 1) {
					deleteFile(tempFile, _ => {
						this.successCallback()
					})
				} else {
					deleteFileVersion(data.fileId, this.item.id, _ => {
						this.successCallback()
					})
				}
				break
			case 'archived':
				if (data.data && data.data.length) {
					let allTasksToDelete = data.data

					allTasksToDelete.forEach(task => {
						deleteItem('task', task, currentAccount, _ => {})
					})

					this.successCallback()
				}

				break
			case 'organisation':
				let otherAccount = null

				userData.accounts.forEach(accountId => {
					let account = allAccounts[accountId]

					if (!otherAccount && account.id !== this.item.id) {
						otherAccount = account
					}
				})

				if (otherAccount && this.item.id === accountData.id) {
					this.props.history.push('/' + otherAccount.slug)

					// we'll check in componentWillUpdate to know when the account's updated, otherwise you'll get logged out.
				} else {
					this.deleteOrganisation()
				}
				break
			case 'milestone':
				// If the milestone has non-archived tasks, only delete the archived ones!
				// Otherwise, just pass through to the default case and let the API do the rest.
				if(data.isShowingArchived && !data.data.deleted_at){
					const tasksToDelete = data.data.tasks.filter(task => {
						return task.deleted_at
					})

					tasksToDelete.forEach(task => {
						deleteItem('task', task, currentAccount, _ => {})
					})

					this.successCallback()
					break
				}
			default:
				deleteItem(dataType, this.item, accountData, itemType => {
					this.successCallback()

					switch (itemType) {
						case 'project':
							history.push(`/${accountData.slug}/projects/`)
							break
					}
				})

				break
		}
	}

	toggleCheckOption = _ => {
		this.setState({
			checkOptionStatus: !this.state.checkOptionStatus
		})
	}

	successCallback = _ => {
		this.props.setLoading(false)
		this.props.closeCallback()
	}

	UNSAFE_componentWillMount = _ => {
		const {
			dataType,
			data
		} = this.props

		switch (dataType) {
			case 'folder':
			case 'file_folder':
				this.item = data.folder
				break
			case 'task':
			case 'project':
			case 'milestone':
			case 'file':
				this.item = data.data
				break
			case 'user':
			case 'stakeholder':
				this.item = data.user
				break
			case 'invitation':
				this.item = data.invitation
				break
			case 'todo':
				this.item = data.todo
				break
			case 'note':
				this.item = data.note
				break
			case 'version':
				this.item = data.version
				break
			case 'chat':
				this.item = data.chat
				break
			default:
				this.item = data
		}
	}

	render() {
		const {
			allProjects,
			allMilestones,
			allTasks,
			allFiles,
			dataType,
			closeCallback
		} = this.props
		
		let parentObject = null
		let objectName
		let warningString = null

		const object = this.item

		// this is done twice cause we want milestone and task to use the second switch's default case
		switch (dataType) {
			case 'milestone':
				parentObject = allProjects[object.project_id]
				break
			case 'task':
				parentObject = allMilestones[object.milestone_id]
				break
		}

		if(object.name){
			objectName = '"' + object.name + '"'
		}

		let prependFrom = true

		switch (dataType) {
			case 'user':
			case 'stakeholder':
				objectName = '"' + object.first_name + ' ' + object.last_name + '"'
				break
			case 'invitation':
				objectName = '"' + object.recipient_email + '"'
				break
			case 'todo':
				if (object.task_id) {
					objectName = '"' + allTasks[object.task_id].name + "'"
					warningString = "Only the todo item will be deleted"
				} else {
					objectName = '"' + object.text + '"'
				}
				break
			case 'file_folder':
				let hasFiles = false

				some(allFiles, file => {
					if(file.file_folder_id == object.id){
						hasFiles = true
						return true
					}
				})

				if(hasFiles){
					warningString = "This file folder contains files, which'll also be deleted. Are you sure?"
				}

				break
			case 'version':
				let tempFile = allFiles[object.file_id];

				if (tempFile && tempFile.versions.length === 1) {
					warningString = `This is the only version, so its parent file will also be deleted.`
				}

				objectName = '"' + object.filename + '"'
				break
			case 'note':
				objectName = '(Empty note)'

				if(object.name){
					objectName = '"'+object.name+'"'
				}else if(object.text){
					const firstLine = paragraphToLines(object.text)[0]

					if(firstLine){
						objectName = '"'+firstLine+'"'
					}
				}
				break
			case 'chat':
				if (object.userIds && object.userIds.length == 1) {
					warningString = "This chat will be permanently deleted."
				}

				if (object.name) {
					objectName = '"' + object.name + '"';
				} else {
					objectName = 'Untitled chat';
				}
				break
			case 'comment':
				const commentLines = paragraphToLines(object.text)

				objectName = '"'+commentLines[0]+'"'
				parentObject = allTasks[object.task_id]
				break
			case 'archived':
				objectName = "You won't be able to recover these."
				break
			case 'session':
				objectName = timeStringFromSession(object)
				parentObject = object.task
				break
			case 'organisation':
				if(object.leaveOnly){
					warningString = "You'll need to be re-invited if you change your mind."
				}else{
					warningString = "Are you sure? You can't undo this, and your team might get mad at you."
				}
				break
			case 'folder':
				if (object.folders.length || object.projects.length) {
					warningString = "This folder is not empty"
				}
				break
			case 'milestone':
				const { isArchived } = this.props

				if(!isArchived){
					const archivedTasks = object && object.tasks.filter(task => {
						return task.deleted_at
					})

					if(archivedTasks.length){
						warningString = `This'll only delete its ${archivedTasks.length} archived task${archivedTasks.length != 1 ? 's' : ''}.`
					}
				}
				break
			case 'progress_update':
				objectName = moment(object.created_at).format('Do MMMM, h:mm a')
				prependFrom = false

				parentObject = {
					name: '"'+object.text+'"'
				}

				break
			case 'meeting':
				objectName = moment(object.start_date).format('MMMM Do')
				break
			case 'bulletin':
			case 'event':
				objectName = '"'+object.title+'"'
				break
			case 'checklist_item':
				objectName = '"'+object.text+'"'
				break
		}

		return (
			<div>
				<div className={'modal-task borders'}>
					{
						objectName ?
							<h3>
								{objectName}
							</h3>
							: null
					}
					{
						parentObject &&
						<span>
							{ prependFrom ? 'from ' : null }{parentObject.name}
						</span>
					}
				</div>
				{
					warningString &&
					<div className="modal-warning">
						<Icon name="fe-alert-triangle" />
						<span>
							{warningString}
						</span>
					</div>
				}
				<Button 
					size={'big'} 
					level={'high'} 
					callback={_ => { this.doAction() }} 
					label={'Yep'} 
					icon={'check'} 
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		allAccounts: state.account.entities.accounts,
		allMilestones: state.account.entities.milestones,
		allProjects: state.account.entities.projects,
		allTasks: state.account.entities.tasks,
		allFiles: state.account.entities.files,
		userData: getCurrentUser(state),
		accountData: getCurrentAccount(state),
	};
}

export default withRouter(connect(mapStateToProps, {
	deleteItem,
	deleteTodo,
	deleteFile,
	deleteFileVersion,
	deleteOrganisation,
	openModal
})(ModalDelete))